import { Button, Col, Space, Table, Tag } from "antd";
import React, { useState } from "react";
import LogoLoader from "../../../components/common/LogoLoader";
import { DATE_FORMAT } from "../../../utils/date";
import dayjs from "dayjs";
import {
  downloadBolPdf,
  downloadShipmentPdf,
} from "../shipments/ShipmentsPage";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";

function OrderShippingDetails({ shippingDetails = [] }) {
  const [downLoadingId, setDownLoadingId] = useState();

  if (!shippingDetails?.length) {
    return null;
  }

  const columns = [
    {
      title: "Shipment Id",
      key: "referenceId",
      render: ({ referenceId, _id: shipmentId }) => {
        return (
          <div className="flex items-center gap-2">
            <Button
              onClick={async () => {
                setDownLoadingId(shipmentId);
                await downloadShipmentPdf({ shipmentId });
                setDownLoadingId(undefined);
              }}
              type="primary"
              icon={<PrinterOutlined />}
              loading={downLoadingId === shipmentId}
              className="flex-shrink-0"
            ></Button>
            {referenceId}
          </div>
        );
      },
    },
    {
      title: "BoL Id",
      key: "bolId",
      render: ({ bols }) => {
        // there will only be one bol for each order in one shipment
        return bols?.map(({ referenceId, _id: bolId }) => {
          return (
            <div key={bolId} className="flex items-center gap-2">
              <Button
                onClick={async () => {
                  setDownLoadingId(bolId);
                  await downloadBolPdf({ bolId });
                  setDownLoadingId(undefined);
                }}
                type="primary"
                icon={<PrinterOutlined />}
                loading={downLoadingId === bolId}
                className="flex-shrink-0"
              ></Button>
              {referenceId}
            </div>
          );
        });
      },
    },
    {
      title: "Carrier Name",
      dataIndex: ["carrier", "name"],
      key: "carrier_name",
      render: (text) => text ?? "-",
    },
    {
      title: "Shipment Date",
      key: "shipmentDate",
      render: ({ shipmentDate }) => {
        return dayjs(shipmentDate).format(DATE_FORMAT);
      },
    },
    {
      title: "Shipped Qty",
      dataIndex: "bols",
      key: "shipped_qty",
      render: (bols) => {
        return bols
          ?.map(({ items = [] }) =>
            items?.map(({ product = {}, quantity = 0 }) => {
              return `[${quantity}] ${product?.name}`;
            }),
          )
          .join(", ");
      },
    },
    // {
    //   title: "Driver",
    //   dataIndex: ["driver", "name"],
    //   key: "driver.name",
    //   render: (text) => text && "-",
    // },
    {
      title: "Tags",
      render: (details) => {
        const {
          referenceId: shipmentId,
          bols = [],
          carrier = {},
          shipmentDate,
        } = details;
        return (
          <Space>
            <CSVLink
              filename={`${shipmentId}_shipment_tags.csv`}
              data={[
                ["Shipment Id", "BoL Id", "Carrier Name", "Shipment Date"],
                [
                  shipmentId,
                  bols
                    ?.map(({ referenceId: bolId }) => {
                      return bolId;
                    })
                    .join(", "),
                  carrier?.name,
                  dayjs(shipmentDate).format(DATE_FORMAT),
                ],
                ["Tags"],
                ...bols?.[0]?.tags?.map((tag) => {
                  return [tag];
                }),
              ]}
            >
              <Button icon={<DownloadOutlined />} type="primary"></Button>
            </CSVLink>
          </Space>
        );
      },
      key: "action",
    },
  ];

  return (
    <>
      <Col span={24} className="flex justify-between border-t-2 pt-2">
        <p className="text-lg">Shipping Details</p>
      </Col>

      <Table
        className="mt-4 w-full"
        dataSource={shippingDetails || []}
        columns={columns}
        rowKey={"_id"}
        // pagination={{
        //   total: receiveSizeBeamListRes?.count || 0,
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onPageChange,
        // }}
        pagination={false}
      />
    </>
  );
}

export default OrderShippingDetails;
